__turbopack_context__.v({
  "clickable": "interaction-module-scss-module__JG9yxq__clickable",
  "cursorDefault": "interaction-module-scss-module__JG9yxq__cursorDefault",
  "nonScrollable": "interaction-module-scss-module__JG9yxq__nonScrollable",
  "outlineNone": "interaction-module-scss-module__JG9yxq__outlineNone",
  "unselectable": "interaction-module-scss-module__JG9yxq__unselectable",
});
